import Wrapper from "../../Layout/Wrapper/wrapper";
import classnames from "classnames";
import SVGS from "../../atoms/svgs";
import "./styles.scss";

const Benefits = (props) => {
  const BenefitsClassNames = classnames("Benefits", {
    "Benefits--mobileColumns": props.mobileColumns,
  });

  return (
    <Wrapper
      classNames={`${BenefitsClassNames} Benefits--${props.type} Benefits--${props.className}`}>
      {props.benefits.map((benefit, index) => {
        const Icon = benefit.svg ? SVGS[benefit.svg] : null;
        return (
          <div
            key={`benefit-${index}`}
            className="Benefits__column">
            {benefit.svg && (
              <Icon
                className="Benefits__icon"
                title={benefit.title}
              />
            )}
            {benefit.title && (
              <div
                className="Benefits__title"
                dangerouslySetInnerHTML={{ __html: benefit.title }}></div>
            )}
          </div>
        );
      })}
    </Wrapper>
  );
};

export default Benefits;
